// extracted by mini-css-extract-plugin
module.exports = {"alert":"SuccessSaveToastWithoutRedux_alert__2_mRd"};